export const imgWidth = 736;
